import { useState } from "react";
import { FaTimes } from "react-icons/fa";

const emptySafari = {
  filterMode: "off", // off | deny | allow
  denyUrls: "",
  allowUrls: "",
  bookmarks: "", // Title | URL pro Zeile
};

function linesToList(text) {
  return String(text || "")
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
}

function bookmarksFromText(text) {
  return linesToList(text).map((line) => {
    const [title, ...rest] = line.split("|");
    const url = rest.join("|").trim() || title.trim();
    return { Title: (title || url).trim(), URL: url };
  }).filter((row) => row.URL);
}

function bookmarksToText(list) {
  return (list || []).map((row) => `${row.Title || row.title || ""} | ${row.URL || row.url || ""}`.trim()).join("\n");
}

export default function SafariControlModal({
  open,
  value,
  onClose,
  onApply,
}) {
  const [form, setForm] = useState(() => ({
    filterMode: value?.filterMode || "off",
    denyUrls: (value?.denyUrls || []).join("\n"),
    allowUrls: (value?.allowUrls || []).join("\n"),
    bookmarks: bookmarksToText(value?.bookmarks || []),
  }));

  if (!open) return null;

  return (
    <div className="teacher-modal-backdrop" role="dialog" aria-modal="true">
      <div className="teacher-modal teacher-modal--wide">
        <div className="teacher-modal__head">
          <h3>Safari im Unterricht</h3>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="teacher-modal__body">
          <label className="form-label">Webfilter</label>
          <select
            className="form-select mb-3"
            value={form.filterMode}
            onChange={(e) => setForm({ ...form, filterMode: e.target.value })}
          >
            <option value="off">Kein zusätzlicher Filter</option>
            <option value="deny">URL-Blacklist (Deny-Liste)</option>
            <option value="allow">URL-Whitelist (nur erlaubt)</option>
          </select>

          {form.filterMode === "deny" ? (
            <div className="mb-3">
              <label className="form-label">Gesperrte URLs (eine pro Zeile)</label>
              <textarea
                className="form-control"
                rows={5}
                value={form.denyUrls}
                onChange={(e) => setForm({ ...form, denyUrls: e.target.value })}
                placeholder={"https://example.com\nyoutube.com"}
              />
            </div>
          ) : null}

          {form.filterMode === "allow" ? (
            <div className="mb-3">
              <label className="form-label">Erlaubte URLs (eine pro Zeile)</label>
              <textarea
                className="form-control"
                rows={5}
                value={form.allowUrls}
                onChange={(e) => setForm({ ...form, allowUrls: e.target.value })}
                placeholder={"https://schule.de\nwikipedia.org"}
              />
            </div>
          ) : null}

          <label className="form-label">Lesezeichen (Title | URL)</label>
          <textarea
            className="form-control"
            rows={5}
            value={form.bookmarks}
            onChange={(e) => setForm({ ...form, bookmarks: e.target.value })}
            placeholder={"Schulportal | https://portal.schule.de"}
          />
        </div>
        <div className="teacher-modal__foot">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Abbrechen</button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              onApply?.({
                filterMode: form.filterMode,
                denyUrls: linesToList(form.denyUrls),
                allowUrls: linesToList(form.allowUrls),
                bookmarks: bookmarksFromText(form.bookmarks),
              });
              onClose?.();
            }}
          >
            Anwenden
          </button>
        </div>
      </div>
    </div>
  );
}

export { emptySafari, bookmarksToText };
